export { createSearchApi } from './api';
export type { SearchApiType } from './api';